/* src/app/components/dashboard/dashboard.component.css */
.admin-nav-button {
  max-width: 290px;
  min-width: 150px;
  min-height: 70px;
  display: inline-block;
  padding: 10px 20px;
  margin: 10px 20px;
  border-radius: 10px;
  line-height: 4;
  cursor: pointer;
  transition: 0.6s;
  background: #79928f;
  color: white;
  font-size: medium;
}
.admin-nav-button:hover {
  background-color: #004c4a;
  color: white;
}
/*# sourceMappingURL=dashboard.component-HJ2SLLXS.css.map */
